/* LunaSafe PDF gifts. Installed only in the unpublished theme copy. */
(function () {
  'use strict';
  if (window.lunaSafePdfGifts) return;
  const alarmProduct = 16654090011015;
  const gifts = [67802626032007, 67802626064775];
  const nativeFetch = window.fetch.bind(window);
  const root = (window.Shopify && window.Shopify.routes.root) || '/';
  let queue = Promise.resolve();
  function enqueue(task) {
    const result = queue.then(task);
    queue = result.catch(function () {});
    return result;
  }
  function plan(cart) {
    const count = cart.items.reduce(function (n, item) {
      return n + (Number(item.product_id) === alarmProduct ? Number(item.quantity) : 0);
    }, 0);
    const updates = {};
    gifts.forEach(function (id, index) {
      const lines = cart.items.filter(function (item) { return Number(item.variant_id) === id; });
      const wanted = count >= 2 ? 1 : 0;
      if (!lines.length && wanted) updates[id] = 1;
      lines.forEach(function (line, i) {
        const quantity = i === 0 ? wanted : 0;
        if (line.quantity !== quantity) updates[line.key] = quantity;
      });
    });
    return updates;
  }
  async function json(url, options) {
    const response = await nativeFetch(url, options);
    if (!response.ok) throw new Error('Could not update your free ebooks. Please try again.');
    return response.json();
  }
  async function sync(sections, sectionsUrl) {
    const cart = await json(root + 'cart.js', {cache: 'no-store'});
    const updates = plan(cart);
    if (!Object.keys(updates).length && !sections) return cart;
    const body = {updates: updates};
    if (sections) { body.sections = sections; body.sections_url = sectionsUrl || window.location.pathname; }
    return json(root + 'cart/update.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)
    });
  }
  function requestSections(body) {
    if (!body) return {};
    if (typeof body.get === 'function') return {sections: body.get('sections'), sections_url: body.get('sections_url')};
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) {
        const params = new URLSearchParams(body);
        return {sections: params.get('sections'), sections_url: params.get('sections_url')};
      }
    }
    return {};
  }
  function showError(error) {
    let box = document.getElementById('lunasafe-pdf-error');
    if (!box) {
      box = document.createElement('div');
      box.id = 'lunasafe-pdf-error';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;bottom:16px;left:16px;right:16px;z-index:99999;padding:14px;background:white;color:#1b3d6d;border:1px solid #1b3d6d';
      document.body.appendChild(box);
    }
    box.textContent = error.message;
  }
  window.fetch = function (input, options) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.origin);
    if (url.origin !== window.location.origin || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) {
      return nativeFetch(input, options);
    }
    return enqueue(async function () {
      let body = options && options.body;
      if (!body && typeof Request !== 'undefined' && input instanceof Request) body = await input.clone().text();
      const requested = requestSections(body);
      const response = await nativeFetch(input, options);
      if (!response.ok) return response;
      let original;
      try { original = await response.clone().json(); } catch (_) { return response; }
      try {
        const cart = await sync(requested.sections, requested.sections_url);
        const result = /\/add(\.js)?$/.test(url.pathname) ? original : cart;
        if (cart.sections) result.sections = cart.sections;
        const headers = new Headers(response.headers);
        headers.delete('content-length'); headers.delete('content-encoding');
        headers.set('content-type', 'application/json');
        return new Response(JSON.stringify(result), {status: response.status, headers: headers});
      } catch (error) {
        showError(error);
        return response; // Never retry an already successful paid-product addition.
      }
    });
  };
  const approved = new WeakSet();
  document.addEventListener('submit', function (event) {
    const form = event.target;
    const submitter = event.submitter;
    const action = new URL(form.action || window.location.href, window.location.origin);
    const checkout = /\/checkout\/?$/.test(action.pathname) ||
      (submitter && submitter.name === 'checkout');
    if (!checkout || approved.has(form)) { approved.delete(form); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    enqueue(function () { return sync(); }).then(function () {
      approved.add(form);
      form.requestSubmit(submitter || undefined);
    }).catch(showError);
  }, true);
  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    enqueue(function () { return sync(); }).then(function () {
      window.location.assign(url.href);
    }).catch(showError);
  }, true);
  window.lunaSafePdfGifts = {plan: plan, sync: function () { return enqueue(function () { return sync(); }); }};
}());
